import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DialogContent from '@material-ui/core/DialogContent';
import ItemsDropdownButton from '../ItemsDropdownButton';

const PromoCodesEditDialog = ({ promoCode, handleClose, handleSubmit, open }) => {
  const [ code, setCode ] = useState(promoCode?.code ?? '');
  const [ dateFrom, setDateFrom ] = useState(promoCode?.date_from);
  const [ dateTo, setDateTo ] = useState(promoCode?.date_to);
  const [ thematicPackage, setThematicPackage ] = useState(promoCode?.thematic_package);
  const [ price, setPrice ] = useState(promoCode?.amount ?? 0);
  const [ email, setEmail ] = useState(promoCode?.customer_email ?? '');

  const convertToUTC = (date) => {
    const utcDay = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      ),
    );

    utcDay.setUTCHours(0, 0, 0, 0);

    return utcDay;
  };

  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
    tomorrow.setHours(0, 0, 0, 0);

    setCode(promoCode?.code ?? '');
    setDateFrom(promoCode?.date_from ? new Date(promoCode?.date_from) : today);
    setDateTo(promoCode?.date_to ? new Date(promoCode?.date_to) : today);
    setPrice(promoCode?.amount ?? 0);
    setThematicPackage(promoCode?.thematic_package);
    setEmail(promoCode?.customer_email ?? '');
  }, [ promoCode ]);

  return (
    <Dialog open={ open } onClose={ handleClose } aria-labelledby='form-dialog-title'>
      <DialogContent>
        <LocalizationProvider dateAdapter={ AdapterDateFns }>
          <Grid container spacing={ 2 }>
            <Grid item xs={ 12 } sm={ 6 }>
              <TextField
                autoFocus
                required
                label='Code'
                color='secondary'
                fullWidth
                value={ code }
                onChange={ (e) => { setCode(e.target.value); } }
              />
            </Grid>

            <Grid item xs={ 12 } sm={ 6 }>
              <TextField
                label='Price'
                fullWidth
                color='secondary'
                required
                value={ price }
                type='number'
                onChange={ (e) => { setPrice(e.target.value); } }
              />
            </Grid>

            <Grid item xs={ 12 } sm={ 6 }>
              <DatePicker
                disableToolbar
                renderInput={ (inputProps) => {
                  return (<TextField { ...inputProps } variant='outlined' />);
                } }
                slotProps={ { textField: { variant: 'outlined' } } }
                variant='inline'
                format='dd/MM/yyyy'
                margin='dense'
                color='secondary'
                maxDate={ dateTo }
                label='Date from'
                required
                value={ dateFrom }
                onChange={ setDateFrom }
                autoOk
                KeyboardButtonProps={ {
                  'aria-label': 'change date',
                } }
              />
            </Grid>

            <Grid item xs={ 12 } sm={ 6 }>
              <DatePicker
                disableToolbar
                renderInput={ (inputProps) => {
                  return (<TextField { ...inputProps } variant='outlined' />);
                } }
                slotProps={ { textField: { variant: 'outlined' } } }
                variant='inline'
                autoOk
                color='secondary'
                format='dd/MM/yyyy'
                required
                minDate={ dateFrom }
                margin='dense'
                label='Date to'
                value={ dateTo }
                onChange={ setDateTo }
                KeyboardButtonProps={ {
                  'aria-label': 'change date',
                } }
              />
            </Grid>

            <Grid item xs={ 12 }>
              <TextField
                color='secondary'
                label='Email'
                fullWidth
                value={ email }
                onChange={ (e) => { setEmail(e.target.value); } }
              />
            </Grid>

            {
              promoCode?.customer_name && promoCode?.customer_family_name && (
                <>
                  <Grid item xs={ 12 }>
                    <TextField
                      color='secondary'
                      label='First name'
                      fullWidth
                      value={ promoCode.customer_name }
                      disabled
                    />
                  </Grid>

                  <Grid item xs={ 12 }>
                    <TextField
                      disabled
                      color='secondary'
                      label='Last name'
                      fullWidth
                      value={ promoCode.customer_family_name }
                    />
                  </Grid>
                </>
              )
            }

            <Grid item xs={ 12 } sm={ 6 }>
              <ItemsDropdownButton
                required
                color='secondary'
                disabled={ false }
                defaultvalue={ thematicPackage }
                onChange={ (v) => {
                  setThematicPackage(v);
                } }
                title='Thematic Package'
                collection='thematicpackages'
              />
            </Grid>

          </Grid>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={ handleClose } color='primary' variant='contained'>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={ () => {
            const dateToISO = convertToUTC(dateTo).toISOString().replace('T00:00:00.000Z', 'T23:59:59.999Z');

            if (thematicPackage && '' !== code) {
              handleSubmit({
                code,
                date_from: convertToUTC(dateFrom).toISOString(),
                date_to: dateToISO,
                thematic_package: thematicPackage.id,
                amount: price,
                customer_email: '' !== email && email !== undefined ? email : null,
              });
            }
          } }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromoCodesEditDialog;
